import { createContext } from 'react';

import { defaultSettings } from '@/mui/constants/config';

export const SettingsContext = createContext({
  ...defaultSettings,
  onToggleMode: () => {},
});
